module.exports = __webpack_public_path__ + "img/e29e867.jpg";